import Review from 'app/shared/model/Review';

const ReviewsForListing = ({
    averageStarLevel = 0,
    totalNumberOfReviews = 0,
    reviews = [],
} = {}) => ({
    averageStarLevel: Number(averageStarLevel),
    totalNumberOfReviews: Number(totalNumberOfReviews),
    reviews: reviews.map(item => Review(item)),
});

export default ReviewsForListing;
